/**
 * One colour per channel, product-wide.
 *
 * A chart that colours by rank repaints Meta when a filter drops Google
 * above it, and the reader learns nothing from colour. Here the colour
 * follows the entity: Meta is Meta's blue in every chart, legend and list,
 * Google Ads is Google's yellow, Google Organic Google's green, and so on.
 * Anything not recognised returns null and the caller falls back to the
 * ranked palette - so a new channel still gets a colour, just not a claimed
 * one.
 *
 * Keys are matched by keyword on the label the API emits (adPlatform.js:
 * 'Meta Ads', 'Google Ads', 'Google Organic', 'Mobile app', 'Direct',
 * 'Email', 'Other' ...), so 'Paid social' and 'Facebook' land on Meta too.
 */
const RULES = [
  [/instagram/i, '#E1306C'],
  [/meta|facebook|paid social/i, '#1877F2'],
  [/google.*(organic|seo)|organic.*google/i, '#34A853'],
  [/google|paid search|adwords/i, '#F9AB00'],
  [/youtube/i, '#FF0033'],
  [/tiktok/i, '#111111'],
  [/linkedin/i, '#0A66C2'],
  [/microsoft|bing/i, '#0078D4'],
  [/pinterest/i, '#E60023'],
  [/snap/i, '#D4B106'],
  [/twitter|\bx ads\b|^x$/i, '#111111'],
  [/whatsapp/i, '#25D366'],
  [/telegram/i, '#229ED9'],
  [/postscript/i, '#2F54EB'],
  [/\bsms\b/i, '#0F7F75'],
  [/email|newsletter|klaviyo/i, '#7C3AED'],
  [/mobile app|\bapp\b|appbrew/i, '#0F8C82'],
  [/organic/i, '#34A853'],
  [/referral/i, '#5E7C8A'],
  [/affiliate|partner/i, '#E9766D'],
  [/direct/i, '#7E8A86'],
  [/^other$/i, '#BCC5C1'],
  // The two halves of every new-vs-returning chart.
  [/^new customers?$|first[- ]time/i, '#2D63D8'],
  [/^returning customers?$|repeat|existing/i, '#7FB0F5'],
];

export function channelColor(name) {
  const s = String(name || '').trim();
  if (!s) return null;
  for (const [re, hex] of RULES) if (re.test(s)) return hex;
  return null;
}

export default channelColor;
